module.exports = __webpack_public_path__ + "img/double-charge-overlay.392709a0.png";